import React from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { wrapFunctionalComponent } from 'utils/framework';
import localeUtils from 'utils/LanguageLocale';
import resourceWrapper from 'utils/framework/resourceWrapper';
import RougeRewardButtonEN from 'components/ProductPage/Type/RewardProduct/RougeRewardButton/locales/RougeRewardButton_en_US';
import RougeRewardButtonFR from 'components/ProductPage/Type/RewardProduct/RougeRewardButton/locales/RougeRewardButton_fr_CA';
import { mediaQueries } from 'style/config';
import { Grid, Text, Link } from 'components/ui';
import Checkbox from 'components/Inputs/Checkbox/Checkbox';
import AddToBasketButton from 'components/AddToBasketButton';
import rrcUtils from 'utils/RrcTermsAndConditions';
import actions from 'actions/Actions';
import skuHelpers from 'utils/skuHelpers';
import basketUtils from 'utils/Basket';
import userUtils from 'utils/User';
import anaConstants from 'analytics/constants';

const { ADD_TO_BASKET_TYPES } = basketUtils;
const getText = resourceWrapper(localeUtils.getLocalisedDataFromResource(RougeRewardButtonEN, RougeRewardButtonFR));

const RougeRewardButton = ({
    product, biExclusiveMsg, addToBasketCallback, buttonWidth, dataAt
}) => {
    const dispatch = useDispatch();
    useSelector(state => state.termsConditions, shallowEqual);
    useSelector(state => state.basket, shallowEqual);

    const acceptTerms = rrcUtils.areRRCTermsConditionsAccepted() || false;
    const checkedTerms = rrcUtils.areRRCTermsConditionsChecked() || false;
    const isRRCInBasket = skuHelpers.isInBasket(product.currentSku.skuId);

    const { currentSku } = product;
    const canUserGetReward = userUtils.isRouge() && (userUtils.isBiPointsBiQualifiedFor(currentSku) || isRRCInBasket);
    const disabled = !currentSku.isEligible || !checkedTerms || userUtils.isAnonymous() || !canUserGetReward;
    const showCheckbox = canUserGetReward && !acceptTerms && !isRRCInBasket;

    const handleTermsClick = event => {
        event.preventDefault();
        dispatch(actions.showRougeRewardCardModal({ isOpen: true, sku: product.currentSku }));
    };

    const handleAcceptTerms = () => {
        rrcUtils.persistAcceptance(checkedTerms);
    };

    const handleCheckTerms = event => {
        rrcUtils.persistAcceptanceCheck(event.target.checked);
    };

    return (
        <Grid
            {...(showCheckbox || biExclusiveMsg
                ? {
                    marginTop: [-2, null, 0],
                    columns: [null, null, 'auto 1fr'],
                    alignItems: 'center',
                    textAlign: ['center', null, 'left'],
                    gap: [null, null, 5]
                }
                : null)}
        >
            <AddToBasketButton
                data-at={Sephora.debug.dataAt(dataAt)}
                width={buttonWidth}
                isRRCModal={true}
                product={product}
                productId={product.productId}
                sku={currentSku}
                onSuccess={handleAcceptTerms}
                analyticsContext={anaConstants.CONTEXT.BASKET_PRODUCT}
                callback={addToBasketCallback}
                variant={isRRCInBasket ? ADD_TO_BASKET_TYPES.PRIMARY : ADD_TO_BASKET_TYPES.SPECIAL}
                disabled={disabled}
                quantity={product.currentSkuQuantity}
            />
            {showCheckbox || biExclusiveMsg ? (
                <div css={{ [mediaQueries.smMax]: { order: -1 } }}>
                    {showCheckbox ? (
                        <Checkbox
                            display='inline-flex'
                            fontSize={['sm', null, 'base']}
                            paddingY={2}
                            onClick={handleCheckTerms}
                            checked={checkedTerms}
                            name='rouge_reward_card'
                        >
                            <span>
                                {getText('checkboxContentDefaultText', false)}{' '}
                                <Link
                                    color='blue'
                                    underline={true}
                                    padding={2}
                                    margin={-2}
                                    onClick={handleTermsClick}
                                    children={getText('checkboxContentDefaultLink', false)}
                                />
                            </span>
                        </Checkbox>
                    ) : (
                        <Text
                            is='p'
                            lineHeight='tight'
                            fontSize={['xs', 'sm']}
                            paddingY={2}
                            maxWidth={[null, null, '16em']}
                            children={biExclusiveMsg}
                        />
                    )}
                </div>
            ) : null}
        </Grid>
    );
};

export default wrapFunctionalComponent(RougeRewardButton, 'RougeRewardButton');
